import type { PropsWithChildren } from 'react';
import type { CalendarProps } from '@progress/kendo-react-dateinputs';

import { useCallback } from 'react';
import { CalendarPropsContext } from '@progress/kendo-react-dateinputs';

import type { ContextPops } from './_base.type';

const CalendarPropsContextProvider = function ({ children }: PropsWithChildren) {
  const calendarProps = useCallback<ContextPops<CalendarProps>>(
    (props) => ({
      ...props,
      navigation: false,
      size: 'small',
    }),
    [],
  );

  return <CalendarPropsContext.Provider value={calendarProps}>{children}</CalendarPropsContext.Provider>;
};

export default CalendarPropsContextProvider;
